import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';

@Component({
  selector: 'aryel-thumb',
  templateUrl: './thumb.component.html',
  styleUrls: ['./thumb.component.scss'],
})
export class ThumbComponent implements OnInit {
  @Input() text: string;
  @Input() image: string;
  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  @Input() disableHover: boolean = false;

  private destroyRef = inject(DestroyRef);

  constructor() {}

  ngOnInit(): void {}
}
